import styled from "styled-components";

import colors from "core/colors";
import BodyText from "core/BodyText";
import { convertPxToRem } from "frontend/components/helpers";

export const BulletPointHeaderText = styled(BodyText).attrs({
    bold: true,
    size: "md",
    copyColor: colors.primary.diamond
})`
    margin-right: ${convertPxToRem(8)};
`;

export const BulletPoint = styled(BodyText).attrs({
    size: "xs",
    copyColor: colors.primary.diamond,
    type: "li"
})``;

export const BulletPoints = styled.ul`
    list-style: disc inside;
    line-height: ${convertPxToRem(17.6)};
    padding-left: ${convertPxToRem(6)};
`;

export const PrimaryPriceText = styled(BodyText).attrs({
    type: "p",
    copyColor: colors.primary.diamond,
    bold: true,
    size: "md"
})``;

export const SecondaryPriceText = styled(BodyText).attrs({
    type: "p",
    copyColor: colors.secondary.dolphin,
    size: "xs"
})``;

export const PriceLayout = styled.div`
    & * {
        text-align: right;
    }

    & ${PrimaryPriceText} {
        margin-bottom: ${convertPxToRem(-4)};
    }
`;

export const HeaderAndPriceLayout = styled.div`
    display: flex;
    justify-content: space-between;

    & ${PriceLayout} {
        margin-left: ${convertPxToRem(12)};
    }
`;

export const CardLayout = styled.div`
    color: ${colors.primary.diamond};
`;

export const HeaderLayout = styled.div`
    & ${BulletPointHeaderText} {
        margin-right: ${convertPxToRem(8)};
    }
`;
